import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useOtherPropertiesHelpers } from "@Client/@Composables/application-standalone/pages/other-properties/useOtherPropertiesHelpers";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import { computed, defineComponent, onMounted, ref, watch } from "@vue/composition-api";
import PageSummarySectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-summary-section-group-layout.vue";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import { useValidatorsHelper } from "@Client/@Composables/application-standalone/validations/useValidatorsHelper";
import ApplicationSectionErrorIcon from "@Client/@Modules/application-standalone/components/helpers/application-section-error-icon.vue";
import RemoveComponentModal from "./../remove-component-modal.vue";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "OtherPropertySummary",
  components: {
    PageSummarySectionGroupLayout,
    SectionTitle,
    ApplicationSectionErrorIcon,
    RemoveComponentModal
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const invalidOtherProperties = ref([]);
    const invalidOtherPropertyExistingMortgages = ref([]);
    const {
      t
    } = useI18n();
    const {
      allApplicants,
      applicantNameFromIndex,
      isApplicantVisibleFromFillOut
    } = useApplicantHelpers();
    const {
      getTextForAddButton,
      editButtonText,
      allowEdit
    } = useSummaryHelpers();
    const {
      getInvalidOtherPropertyExistingMortgages,
      getInvalidOtherProperties
    } = useValidatorsHelper();
    const {
      addEmptyOtherProperty,
      deleteOtherProperty,
      applicantHasOtherProperties,
      otherPropertySummarySubtitle
    } = useOtherPropertiesHelpers();
    const addPropertyButtonText = applicant => {
      return getTextForAddButton("application-standalone.pages.properties.addAdditionalProperty", {
        iteratee: applicantHasOtherProperties,
        singleValue: applicant["other-properties"]
      });
    };
    onMounted(() => {
      updateInvalidProperties();
    });
    const updateInvalidProperties = async () => {
      invalidOtherProperties.value = await getInvalidOtherProperties();
      invalidOtherPropertyExistingMortgages.value = await getInvalidOtherPropertyExistingMortgages();
    };
    const areInvalidProperties = computed(() => !!invalidOtherProperties.value.length || !!invalidOtherPropertyExistingMortgages.value.length);
    watch(areInvalidProperties, newValue => emit("disable-save", newValue), {
      immediate: true
    });
    const handleAddOtherProperty = (applicantIndex, applicantId) => {
      addEmptyOtherProperty(applicantIndex);
      const applicant = allApplicants.value[applicantIndex];
      if (applicant) {
        handleNavigation(applicantIndex, applicant["other-properties"].length - 1, applicantId);
      }
    };
    const handleNavigation = (applicantIndex, otherPropertyIndex, applicantId = "") => {
      emit("navigate", {
        applicantIndex,
        otherPropertyIndex,
        applicantId
      });
    };
    const isInvalid = (appIndex, index) => {
      return invalidOtherProperties.value.some(({
        applicantIndex,
        otherPropertyIndex
      }) => applicantIndex === appIndex && index === otherPropertyIndex) || invalidOtherPropertyExistingMortgages.value.some(({
        applicantIndex,
        otherPropertyIndex
      }) => applicantIndex === appIndex && index === otherPropertyIndex);
    };
    const firstErrorId = computed(() => {
      var _ref, _invalidOtherProperti, _invalidOtherProperti2, _invalidOtherProperty;
      return (_ref = (_invalidOtherProperti = (_invalidOtherProperti2 = invalidOtherProperties.value) == null ? void 0 : _invalidOtherProperti2[0]) != null ? _invalidOtherProperti : (_invalidOtherProperty = invalidOtherPropertyExistingMortgages.value) == null ? void 0 : _invalidOtherProperty[0]) != null ? _ref : null;
    });
    const handleDelete = ({
      applicantIndex,
      otherPropertyIndex
    }) => {
      deleteOtherProperty(applicantIndex, otherPropertyIndex);
      emit("save");
      updateInvalidProperties();
    };
    const modalText = computed(() => {
      return t("application-form.removeComponentModalMessage", {
        componentType: "property"
      });
    });
    const removeComponentModal = ref();
    const openDeletionModal = data => {
      var _removeComponentModal;
      removeComponentModal == null ? void 0 : (_removeComponentModal = removeComponentModal.value) == null ? void 0 : _removeComponentModal.openModal(data);
    };
    return {
      handleDelete,
      handleAddOtherProperty,
      allApplicants,
      applicantNameFromIndex,
      handleNavigation,
      deleteOtherProperty,
      otherPropertySummarySubtitle,
      applicantHasOtherProperties,
      addPropertyButtonText,
      isApplicantVisibleFromFillOut,
      isInvalid,
      updateInvalidProperties,
      firstErrorId,
      invalidOtherProperties,
      invalidOtherPropertyExistingMortgages,
      allowEdit,
      editButtonText,
      modalText,
      removeComponentModal,
      openDeletionModal
    };
  }
});